import { readUserById } from "@/api";
import { AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Divider, Stack } from "@mui/material";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { AffiliatedOrganizations } from "./components/AffiliatedOrganizations";
import { UserActivity } from "./components/UserActivity";
import { UserInformation } from "./components/UserInformation";

const UserDetails = () => {
    const { userId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("User");

    if (!userId) throw new Error("User ID is required");

    const { data: user } = useSuspenseQuery({
        queryKey: ["admin-user-details", Number(userId)],
        queryFn: () => readUserById(Number(userId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Users", path: "users" },
            { label: user.first_name + " " + user.last_name },
        ]);
    });

    return (
        <>
            <AdminPageHeader
                title={user.first_name + " " + user.last_name}
                subtitle="Profile, activity, and organization memberships"
            />
            <Stack gap={3} divider={<Divider />} className="mt-6">
                <UserInformation user={user} />
                <UserActivity user={user} />
                <AffiliatedOrganizations user={user} />
            </Stack>
        </>
    );
};

export default UserDetails;
